import { render } from "./note-type.vue?vue&type=template&id=2ce30007"
import script from "./note-type.vue?vue&type=script&lang=js"
export * from "./note-type.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__